var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigAdm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.717 3.35a2.527 2.527 0 012.566 0l5.434 3.194A2.621 2.621 0 0120 8.806v6.388c0 .933-.49 1.795-1.283 2.262l-5.434 3.194a2.526 2.526 0 01-2.566 0l-5.434-3.194A2.621 2.621 0 014 15.194V8.806c0-.933.49-1.796 1.283-2.262l5.434-3.194z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
export default SvgConfigAdm;